import React from 'react';
import styled from 'styled-components';

const GalaryBlock = () => (
  <GalaryBlockComponentWrapDiv>
    <HotelImageComponentWrapDiv></HotelImageComponentWrapDiv>
  </GalaryBlockComponentWrapDiv>
);

export default GalaryBlock;

const GalaryBlockComponentWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:41%;

  padding-right:${props.theme.spacing.small.s5};
`,
);

const HotelImageComponentWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:98%;
  background-image: linear-gradient(to left, #f4f4f4, #ececec);
  border-radius:${props.theme.misc.borderRadius.small};
  height:21rem;

`,
);

